/**
*
* RedTickets
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import Wrapper from 'components/Templates/dynamics/Wrapper';

import RedTicketsTicket from './RedTicketsTicket';

import defaultTextValues from './defaultTextValues';

import TicketsPlaceholder from './styles/TicketsPlaceholder';


class RedTickets extends React.PureComponent {
  constructor() {
    super();
    
    this.handleClose = this.handleClose.bind(this);
    this.getTicket = this.getTicket.bind(this);

  }

  handleClose() {
    this.setState({
      ticket: ''
    });
  }

  getTicket(ticket, ticketsData) {

    let data = {};

    if (ticket && ticket.ticketId && ticketsData && ticketsData.length > 0) {

      for (let index = 0; index < ticketsData.length; index++) {
        const element = ticketsData[index];
        if (element.ticketId === ticket.ticketId) data = element;
      }
  
    }    

    return data;

  }


  render() {

      const {
        commonData,
        openEditor,
        commonProps,
        tickets,
        ticketsData
      } = this.props;

      const {
        isEditor
      } = commonProps;

      const {
        componentPayload
      } = commonData;

      const {
        ticketHighlighted
      } = componentPayload;


      const ticketsContent = tickets ? tickets.map((ticketItem) => {
     
        const ticketContent = this.getTicket(ticketItem, ticketsData);

        if (ticketContent && ticketContent.ticketId && !ticketContent.isArchived) {
          const hasTito = ticketContent && ticketContent.customUrl && ticketContent.customUrl.includes('ti.to');
          return (
            <RedTicketsTicket
              key={`RedTickets-TicketComponent-${ticketItem.ticketId}`+ticketContent.customUrl}
              {...this.props}
              handlePurchase={this.handlePurchase}
              ticketContent={ticketContent}
              highlighted={ticketHighlighted === ticketItem.ticketId}
              hasTito={hasTito}
            />
          );
        }
      }) : '';


      return (
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapper'}
          editorData={
            {
              editorType: 'wrapper',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'wrapperWithMargin'}
            editorData={
              {
                editorType: 'wrapperWithMargin',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'sectionTitle'}
              type={'text'}
              defaultValues={defaultTextValues}
              editorData={
                {
                  editorType: 'sectionTitle',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'paragraph'}
              type={'text'}
              editorData={
                {
                  editorType: 'paragraph',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'ticketContainer'}
              editorData={
              {
                editorType: 'ticketContainer',
                ...commonData
              }
            }
            >
            {isEditor && ticketsContent.length < 1 ? (
              <TicketsPlaceholder>
                <span>
                  {'Select Tickets inside Section settings.' }
                </span>
              </TicketsPlaceholder>
            ): ticketsContent}
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'buttonsCenterWrapper'}
              editorData={
                {
                  editorType: 'buttonsCenterWrapper',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                type={'text'}
                typeOfStyle={'buttonSecondary'}
                editorData={
                  {
                    editorType: 'buttonSecondary',
                    ...commonData
                  }
                }
              />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      );
  }
}

RedTickets.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  tickets: PropTypes.array
};

export default RedTickets;
